// Fix this file, do not use any as the type
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-explicit-any */
function getDataUri(url: any, callback: any): any {
  const image: any = new Image()

  image.onload = function () {
    const canvas: any = document.createElement('canvas')
    canvas.width = this.naturalWidth // or 'width' if you want a special/scaled size
    canvas.height = this.naturalHeight // or 'height' if you want a special/scaled size

    canvas.getContext('2d').drawImage(this, 0, 0)
    // ... or get as Data URI
    callback(canvas.toDataURL('image/png'))
  }

  image.src = url
}

export default getDataUri
